import { useContext } from 'react';
import { CartContext, CartDispatchContext } from './index';
import { addToCart, removeFromCart } from './actions';
import { PackageType } from '../../api/package';

export function useCart() {
  return useContext(CartContext);
}

export function useCartDispatch() {
  const dispatch = useContext(CartDispatchContext);
  if (!dispatch) throw new Error('useAddToCart must be within CartProvider!');
  return dispatch;
}

export function useAddToCart() {
  const dispatch = useCartDispatch();
  return (pkg: PackageType) => dispatch(addToCart(pkg));
}

export function useRemoveFromCart() {
  const dispatch = useCartDispatch();
  return (pkgId: number) => dispatch(removeFromCart(pkgId));
}

export function useContainPackage(pkgId: number) {
  const cart = useCart();
  return cart.findIndex(({ id }) => pkgId === id) >= 0;
}
